import { useMemo } from "react";

interface UseComputeDataGridHeightReturnData {
  computedHeight: number;
}

export const useComputeDataGridHeight = (
  dataLength: number,
  rowHeight: number,
  hasTotalRow: boolean,
  hasFiltersEnabled: boolean,
  variant: string,
  isScrollable = false
): UseComputeDataGridHeightReturnData => {
  const computedHeight = useMemo(() => {
    let gridLengthBuffer = hasFiltersEnabled ? 0 : -1;
    if (hasTotalRow) gridLengthBuffer = hasFiltersEnabled ? 1 : 0;

    return (dataLength + gridLengthBuffer) * rowHeight + 2 * rowHeight + (isScrollable ? 18 : 0);
  }, [dataLength, rowHeight, hasTotalRow, hasFiltersEnabled, variant, isScrollable]);

  return {
    computedHeight,
  };
};
